import { TableOrder } from './types';

// ----------------------------------------------------------------------

export const MIN_VISIBLE_TABLE_ROWS = 4;

export function emptyRows(page: number, rowsPerPage: number, arrayLength: number) {
  return page > 0 ? Math.max(0, (1 + page) * rowsPerPage - arrayLength) : 0;
}

/**
 * Empty rows to show so the table has at least minVisibleRows row slots on the current page.
 * Use for paginated tables; combines pagination empty rows with a minimum visible row count.
 * When there are no data rows at all (arrayLength === 0), returns 0 so we only show the "No … found" state.
 */
export function emptyRowsWithMin(
  page: number,
  rowsPerPage: number,
  arrayLength: number,
  minVisibleRows: number = MIN_VISIBLE_TABLE_ROWS
) {
  if (arrayLength === 0) return 0;
  const dataRowsOnPage = Math.min(rowsPerPage, Math.max(0, arrayLength - page * rowsPerPage));
  const paginationEmpty = emptyRows(page, rowsPerPage, arrayLength);
  return Math.max(0, Math.max(paginationEmpty, minVisibleRows - dataRowsOnPage));
}

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  const aValue = a[orderBy];
  const bValue = b[orderBy];

  if (bValue === null || bValue === undefined) {
    return -1;
  }
  if (aValue === null || aValue === undefined) {
    return 1;
  }
  if (bValue < aValue) {
    return -1;
  }
  if (bValue > aValue) {
    return 1;
  }
  return 0;
}

export function getComparator<Key extends keyof any>(
  order: TableOrder,
  orderBy: Key
): (
  a: { [key in Key]: number | string | Date | boolean | null | undefined },
  b: { [key in Key]: number | string | Date | boolean | null | undefined }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
